// @ts-strict-ignore
import * as React from 'react';
import styles from '../index.module.styl';
export const Content = _ref => {
  let {
    children
  } = _ref;
  return <div className={styles.content} data-sentry-component="Content" data-sentry-source-file="content.tsx">{children}</div>;
};